// extracted by mini-css-extract-plugin
export default {"organizationsTable":"xAcG8FG2AZeInf_NWlYl","shareButton":"m39FDYOPXQGfHmNlkYkg","organizationName":"y4k3cvqS3PY7BYkWaX7X","sectionTitle":"iIpEmN3LGFycr8NiwWVG"};